<template>
  <div class="layout-video-banner__wrapper">
    <div class="layout-video-banner__container">
      <p
        v-if="$helper.isNotAmpPage($route.name)"
        class="layout-video-banner__title subtitle-3"
      >
        Featured Videos
      </p>

      <a-video-banner
        v-if="$helper.isNotAmpPage($route.name)"
        :video-banner-type="videoBannerType"
        class="layout-video-banner__banner"
      />

      <!-- TODO refactor: pass videoBannerType for amp as a prop -->
      <article-amp-video-banner v-else />
    </div>
  </div>
</template>

<script>
import AVideoBanner from 'shared/AVideoBanner/index.vue'
import { VIDEO_BANNER_TYPE } from 'enums/video-banner'
import mixins from '@/utils/mixins'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import ArticleAmpVideoBanner from '@/components/_sections/amp/ArticleAmpVideoBanner/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

export default {
  name: 'ALayoutVideoBanner',
  mixins: [mixins.oneTrust, hydrationHelpers],
  components: { ArticleAmpVideoBanner, AVideoBanner },
  props: {
    videoBannerType: propValidator(
      [PROP_TYPES.STRING],
      false,
      VIDEO_BANNER_TYPE.ARTICLE
    )
  },
  consts: {
    VIDEO_BANNER_TYPE
  }
}
</script>

<style lang="scss" scoped>
.layout-video-banner__wrapper {
  display: flex;
  justify-content: center;
  background-color: $c--black;
  margin-bottom: -20px;

  $padding: (
    $above-desktop-xl: 40px 60px,
    $tablet: 40px $tablet-body-padding,
    $mobile: 24px $mobile-body-padding
  );

  $margin-top: (
    $above-desktop-xl: 40px,
    $tablet: 32px,
    $mobile: 24px
  );

  @include setStyleByBreakpoint('margin-top', $margin-top);
  @include setStyleByBreakpoint('padding', $padding);

  .layout-video-banner__container {
    width: 100%;
    max-width: $desktop-full-hd-container;
  }

  .layout-video-banner__title {
    color: $c--white;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .layout-video-banner__banner {
    display: flex;
    justify-content: center;
  }
}
</style>

<style lang="scss">
#__nuxt .amp-layout__wrapper {
  .layout-video-banner__wrapper {
    padding: 24px $mobile-body-padding;
  }
}
</style>
